<script setup lang="ts">
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<template>
  <component :is="route.meta.layout" v-if="route.meta.layout">
    <RouterView v-slot="{ Component }">
      <component :is="Component" />
    </RouterView>
  </component>

  <RouterView v-else v-slot="{ Component }">
    <component :is="Component" />
  </RouterView>
</template>